import React, { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import api from "@/lib/api";

export default function FAQSection({ faqs: providedFaqs, title = "Frequently Asked Questions" }) {
  const [faqs, setFaqs] = useState(providedFaqs || null);

  useEffect(() => {
    if (!providedFaqs) {
      api.get("/faqs").then((res) => setFaqs(res.data)).catch(() => setFaqs([]));
    }
  }, [providedFaqs]);

  if (!faqs || faqs.length === 0) return null;

  return (
    <section data-testid="faq-section" className="py-16 sm:py-20 bg-[#FDFCFB]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">Got Questions?</span>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mt-3">{title}</h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#E5E1DA]">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-medium text-[#1A1A1A] hover:text-[var(--brand-primary)]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-[var(--brand-secondary)] leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
